import en from '@content/copy/en.json'
import parent from '@content/copy/parent.tr.json'
import child from '@content/copy/tr.json'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

/**
 * CONVENTIONS §4: user facing Turkish lives in content/ JSON, so i18next reads those files
 * directly instead of keeping a second copy under src. Two namespaces: `child` for everything
 * the child sees, `parent` for the veli area.
 */

export const NAMESPACES = ['child', 'parent'] as const
export type Namespace = (typeof NAMESPACES)[number]

export const resources = {
  tr: { child, parent },
  en: { child: en, parent: en },
} as const

export async function initI18n(language: 'tr' | 'en' = 'tr') {
  if (i18next.isInitialized) return i18next
  await i18next.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: 'tr',
    defaultNS: 'child',
    ns: NAMESPACES,
    // The copy files use {name:case} placeholders that shared/src/tr.ts resolves, so
    // i18next's own {{ }} interpolation never sees them.
    interpolation: { escapeValue: false },
    returnNull: false,
  })
  return i18next
}

export { i18next }
